import { TCocktail, TDdpCta, TRecommendationCocktail } from "@/shared/types"
import { IconArrow } from "../icon/master"
import { DdpCta } from "./DdpCta"
import { LinkWrapper } from "./LinkWrapper"
import { useAppStore, useCmsStore } from "../AppHooks"
import { useEffect, useRef, useState } from "react"
import { getCocktailByIds, interaction } from "@/shared/utils"
import { tracking } from "@/shared/tracking"
import { GetFpSiteName } from "@/shared/appInit"

export function CocktailList(props: { className?: string, cocktailList?: Array<TRecommendationCocktail>, cta: Array<TDdpCta> | TDdpCta | string }) {
    const { className, cocktailList, cta } = props
    const [finalCocktailList, setFinalCocktailList] = useState<Array<TCocktail>>([])
    useEffect(() => {
        if (!cocktailList) return
        getCocktailByIds(cocktailList.map((item) => item.cocktailId)).then((cocktails) => {
            setFinalCocktailList(cocktails)
        })
    }, [props.cocktailList])
    const { locale, storeConfig: {
        cocktailDetailOn,
        id: SiteId
    } } = useCmsStore()!
    const { results } = useAppStore()

    return (
        <div className={`cocktail-list ${className}`}>
            {finalCocktailList.length > 0 && cocktailList?.map((item, index) => {
                const cocktailInfo = finalCocktailList.find((cocktail) => cocktail.id.toLowerCase() === item.cocktailId.toLowerCase())
                if (!cocktailInfo) return null
                return <LinkWrapper
                    key={`${index}+${cocktailInfo?.id}`}
                    url={`${cocktailDetailOn ? '/cocktaildetail?cocktailId=' + item.cocktailId : ''}`}
                    onClick={() => {
                        if (cocktailDetailOn) {
                            tracking({
                                "event": "custom_event",
                                "event_name": "recipe_tile",
                                "recipe_name": cocktailInfo.cocktailTitle,
                                "brand": {
                                    "key": null,
                                    "ref": null,
                                    "props": {
                                        "children": "Ketel One"
                                    },
                                    "_owner": null
                                },
                                "recipe_id": cocktailInfo?.id,
                                "click_text": typeof cta === 'string' ? cta : Array.isArray(cta) ? cta[0].text : '',
                                "destination_page_path": `${locale}${cocktailDetailOn ? '/cocktaildetail?cocktailId=' + item.cocktailId : ''}`
                            })
                            interaction([cocktailInfo.id], GetFpSiteName(SiteId), results?.consumerId || '', 'Click')
                        }
                    }}
                >
                    <div className='cocktail-item'>
                        <div className="top-content-wrapper">
                            <div className='cocktail-media-wrapper'>
                                <img className='cocktail-img' src={cocktailInfo?.recipeFirstImage?.url} alt={cocktailInfo?.cocktailTitle} />
                                <div className='cocktail-compatible'>{Math.round(item.compatibility)}% Compatible</div>
                            </div>
                            <h2 className='cocktail-title'>{cocktailInfo?.cocktailTitle}</h2>
                            <div className="cocktail-desc" dangerouslySetInnerHTML={{ __html: cocktailInfo?.cocktailDescription || '' }}></div>
                        </div>
                        {
                            cocktailDetailOn && <>
                                {
                                    typeof cta === 'string' && cta && <DdpCta className='cta-discover' cta={{
                                        text: cta,
                                        show: true,
                                        url: ''
                                    }} >
                                        <IconArrow right />
                                    </DdpCta>
                                }
                                {
                                    typeof cta !== 'string' && cta && <DdpCta className='cta-discover' cta={{
                                        ...Array.isArray(cta) ? cta[0] : cta,
                                        url: ''
                                    }} >
                                        <IconArrow right />
                                    </DdpCta>
                                }
                            </>
                        }

                    </div>
                </LinkWrapper>
            }
            )}
        </div>
    )
}